import styled, { css } from 'styled-components'

const ARROW_COLOR = '#fff'

const arrowStyles = css`
  display: block;
  position: absolute;

  &:before,
  &:after {
    content: '';
    position: absolute;
    z-index: -1;
  }

  [data-placement^='bottom'] > & {
    top: -8px;

    &:before,
    &:after {
      transform: translateX(-50%);
    }

    &:after {
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid ${ARROW_COLOR};
    }
  }

  [data-placement='bottom-end'] > & {
    top: -8px;

    &:after {
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid ${ARROW_COLOR};
    }
  }

  [data-placement^='top'] > & {
    bottom: -8px;

    &:before,
    &:after {
      transform: translateX(-50%) rotate(180deg);
    }

    &:after {
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid ${ARROW_COLOR};
      bottom: 0;
    }
  }

  [data-placement^='right'] > & {
    left: -12px;

    &:before,
    &:after {
      transform: translateY(-50%) rotate(-90deg);
    }

    &:after {
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid ${ARROW_COLOR};
    }
  }

  [data-placement^='left'] > & {
    right: -12px;

    &:before,
    &:after {
      transform: translateY(-50%) rotate(90deg);
    }

    &:after {
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid ${ARROW_COLOR};
      right: 0;
    }
  }
`

const arrowBorderStyles = css`
  [data-placement^='bottom'] > &,
  [data-placement^='bottom-end'] > & {
    &:before {
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 9px solid ${({ theme }) => theme.colors.border.dark.low};
      top: -2px;
    }
  }

  [data-placement^='top'] > & {
    &:before {
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 9px solid ${({ theme }) => theme.colors.border.dark.low};
      bottom: -2px;
    }
  }

  [data-placement^='right'] > & {
    &:before {
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid ${({ theme }) => theme.colors.border.dark.low};
      left: -3px;
    }
  }

  [data-placement^='left'] > & {
    &:before {
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid ${({ theme }) => theme.colors.border.dark.low};
      right: -3px;
    }
  }
`

const PopoverArrow = styled.span.attrs(props => ({
  border: true,
  arrowColor: ARROW_COLOR,
}))`
  ${arrowStyles};
  ${props => props.border && arrowBorderStyles};
  ${props =>
    props.arrowColor &&
    css`
      &:after {
        border-bottom-color: ${props.arrowColor} !important;
      }
    `};
`

export default PopoverArrow
